import type { ReactNode } from 'react';

export const symbol_signal_cellular_add: ReactNode = (
	<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 -960 960 960">
		<path
			fill="currentColor"
			d="M740-200h-90q-12.75 0-21.37-8.68-8.63-8.67-8.63-21.5 0-12.82 8.63-21.32 8.62-8.5 21.37-8.5h90v-90q0-12.75 8.68-21.38 8.67-8.62 21.5-8.62 12.82 0 21.32 8.62 8.5 8.63 8.5 21.38v90h90q12.75 0 21.38 8.68 8.62 8.67 8.62 21.5 0 12.82-8.62 21.32-8.63 8.5-21.38 8.5h-90v90q0 12.75-8.68 21.37-8.67 8.63-21.5 8.63-12.82 0-21.32-8.63Q740-97.25 740-110v-90ZM152-80q-13.5 0-21.75-9.5T122-109.67q0-5.33 2.05-10.93 2.04-5.6 6.95-10.4l698-698q5-5 10.5-7t10.83-2q10.67 0 20.17 8.25Q880-821.5 880-808v338q0 12.75-8.68 21.37-8.67 8.63-21.5 8.63-12.82 0-21.32-8.63-8.5-8.62-8.5-21.37v-266L224-140h306q12.75 0 21.38 8.68 8.62 8.67 8.62 21.5 0 12.82-8.62 21.32Q542.75-80 530-80H152Zm72-60 596-596-183 183-140.5 140.5-128 128L224-140Z"
		/>
	</svg>
);
